import {absCenter, panel} from '@xpertdox_js/xdstyle';

export default {
  container: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    height: '100%',
  },
  content: {
    ...absCenter,
    panel,
  }
}
